<section class="bg-white">
  @if (displayedReview != undefined) {
    <div class="place-self-end ms-auto">
      <app-help-popover [iconColor]="'text-amazone-orange'" [paragraphs]="paragraphs"></app-help-popover>
    </div>
    <div class="w-full">
      <h2 class="mb-2 text-xl font-semibold leading-none text-gray-700 md:text-2xl flex justify-between">
        Review by {{ reviewRole }}
      </h2>
      <app-diff-viewer [diffFields]="diffFields"></app-diff-viewer>
      <dl class="bg-amazone-beige p-2 rounded-lg mb-6">
        <dt class="mb-2 font-semibold leading-none text-gray-700">Review notes</dt>
        <dd class="mb-4 font-light text-gray-500 sm:mb-5">
          @for (line of commonUtils.breakIntoLines(reviewNotes); track $index) {
            <div>
              {{ line }}
            </div>
          }
        </dd>
      </dl>
    </div>
  } @else {
    <div class="flex justify-center items-center mt-8">
      <h2 class="mb-2 text-xl font-semibold leading-none text-amazone-orange md:text-2xl">no review available</h2>
    </div>
  }
</section>
<div>
  @if (canMerge) {
    <button
      class="crud-btn-sidebar"
      (click)="mergeReview()"
      appAgentAction
      agent="review-request-merge-merge"
      businessObject="reviewRequest"
      [businessId]="$safeNavigationMigration(reviewable?.id)"
      action="merge"
    >
      <app-thumb-up-icon></app-thumb-up-icon>
    </button>
  }
  @if (canDelete) {
    <button
      class="crud-btn-sidebar bottom-48"
      (click)="discardReviewDecisionModal.openModal(); $event.stopPropagation()"
      appAgentAction
      agent="review-request-merge-discard"
      businessObject="reviewRequest"
      [businessId]="$safeNavigationMigration(reviewable?.id)"
      action="discard"
    >
      <app-delete-icon></app-delete-icon>
    </button>
  }
</div>
<app-decision-modal
  #discardReviewDecisionModal
  (decision)="onDiscardReviewDecision($event)"
  [header]="'Discard Review'"
  businessObject="reviewRequest"
  [details]="['This Review will be deleted. Do you want to proceed?']"
></app-decision-modal>

<app-merge-review-propagation-modal
  [executionType]="executionType.Merge"
  #mergeSiblingsModal
></app-merge-review-propagation-modal>

<app-delete-review-propagation-modal
  [executionType]="executionType.Delete"
  #deleteReviewPropagationModal
></app-delete-review-propagation-modal>
